let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("loug9")).then(() => parcelRequire('iYJQV'));